module.exports = __webpack_public_path__ + "img/emo_49.3506f66b.png";